module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('appHeader', {
    attrs: {
      "dataStoryId": _vm.currentStory.dataStoryId,
      "dataStoryIndex": _vm.currentStory.dataStoryIndex,
      "dataSectionIndex": _vm.currentSection.dataSectionIndex,
      "theme": _vm.currentSection.theme
    },
    on: {
      "toggleSidebar": function($event) {
        _vm.toggleSidebar()
      }
    }
  }), _vm._v(" "), _c('StoryTitle', {
    attrs: {
      "dataAnchor": _vm.currentSection.dataAnchor,
      "dataStoryTitle": _vm.currentStory.dataStoryTitle,
      "theme": _vm.currentSection.theme
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebarHasToggle),
      expression: "sidebarHasToggle"
    }],
    class: ['custom-dimmed', {
      'custom-dimmed--visible': _vm.sidebarHasToggle
    }, {
      'custom-dimmed--invisible': !_vm.sidebarHasToggle
    }],
    on: {
      "click": function($event) {
        _vm.closeSidebar()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui right vertical sidebar labeled icon menu",
    attrs: {
      "id": "menu"
    }
  }, [_c('a', {
    class: ['item', {
      'active': _vm.currentStory.dataStoryIndex === 1
    }],
    on: {
      "click": function($event) {
        _vm.moveTo('what-is-going-on-in-KBlvd--section-1', 1)
      }
    }
  }, [_vm._v("\n      1. 凱道的原住民流浪記\n    ")]), _vm._v(" "), _c('a', {
    class: ['item', {
      'active': _vm.currentStory.dataStoryIndex === 2
    }],
    on: {
      "click": function($event) {
        _vm.moveTo('what-is-traditional-indigenous-territories--section-1', 2)
      }
    }
  }, [_vm._v("\n      2. 什麼是傳統領域？\n    ")]), _vm._v(" "), _c('a', {
    class: ['item', {
      'active': _vm.currentStory.dataStoryIndex === 3
    }],
    on: {
      "click": function($event) {
        _vm.moveTo('the-meaning-of-traditional-indigenous-territories--section-1', 3)
      }
    }
  }, [_vm._v("\n      3. 回不了家的原住民\n    ")]), _vm._v(" "), _c('a', {
    class: ['item', {
      'active': _vm.currentStory.dataStoryIndex === 4
    }],
    on: {
      "click": function($event) {
        _vm.moveTo('the-issues-and-solutions-on-traditional-indigenous-territories--section-1', 4)
      }
    }
  }, [_vm._v("\n      4. 傳統領域對原住民來說是什麼？\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "ui left sidebar vertical menu",
    attrs: {
      "id": "readmore"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentSection.moreTitle)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentSection.moreSubtitles)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui bottom sidebar vertical",
    attrs: {
      "id": "issues-content"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentSection.currentIssueContent)
    }
  })]), _vm._v(" "), _c('ButtonMore', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSection.showIssueContent),
      expression: "currentSection.showIssueContent"
    }],
    attrs: {
      "theme": 'hamburger--background-dark',
      "state": 'close-issue-btn',
      "closebtn": 'closebtn'
    },
    on: {
      "closeissues": _vm.closeIssues
    }
  }), _vm._v(" "), _c('ButtonMore', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSection.showMoreContent),
      expression: "currentSection.showMoreContent"
    }],
    attrs: {
      "theme": 'hamburger--background-light',
      "state": 'close-more-btn',
      "closebtn": 'closebtn'
    },
    on: {
      "closemore": _vm.closeMore
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSection.hasMore),
      expression: "currentSection.hasMore"
    }],
    staticClass: "container-more"
  }, [_c('ButtonMore', {
    attrs: {
      "state": 'open-more-btn'
    },
    on: {
      "more": _vm.readMore
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "container-more__caption"
  }, [_vm._v(_vm._s(_vm.currentSection.moreCaption))])], 1), _vm._v(" "), _c('div', {
    staticClass: "pusher"
  }, [_c('div', {
    attrs: {
      "id": "fullpage"
    }
  }, [_vm._l((_vm.stories), function(story, storyIndex) {
    return _vm._l((story.sections), function(section, sectionIndex) {
      return _c('section', {
        staticClass: "section",
        attrs: {
          "data-anchor": section.dataAnchor,
          "data-story-id": story.dataStoryId,
          "data-story-title": story.dataStoryTitle,
          "data-story-index": (+storyIndex),
          "data-story-total": _vm.stories.length,
          "data-section-index": (+sectionIndex) + 1,
          "data-section-total": story.sections.length,
          "theme": section.theme
        }
      }, [(section.dataAnchor === 'landing-page') ? _c('video', {
        attrs: {
          "poster": "",
          "id": "bgvid",
          "playsinline": "",
          "autoplay": "",
          "muted": "",
          "loop": ""
        }
      }, [_c('source', {
        attrs: {
          "id": "bgvid-source",
          "src": ""
        }
      })]) : _vm._e(), _vm._v(" "), (section.dataAnchor === 'landing-page') ? _c('ButtonDown') : _vm._e(), _vm._v(" "), (section.dataAnchor === 'what-is-traditional-indigenous-territories--section-2') ? _c('img', {
        staticClass: "taiwan-line",
        attrs: {
          "src": "static/taiwan_line.png",
          "alt": ""
        }
      }) : _vm._e(), _vm._v(" "), (section.dataAnchor === 'what-is-traditional-indigenous-territories--section-2') ? _c('img', {
        staticClass: "taiwan-color taiwan-color--invisible",
        attrs: {
          "src": "static/taiwan_color.png",
          "alt": ""
        }
      }) : _vm._e(), _vm._v(" "), (section.hasBackgroundPhoto) ? _c('div', {
        staticClass: "photo-credit"
      }, [_vm._v(_vm._s(section.photoCredit))]) : _vm._e(), _vm._v(" "), _c('Description', {
        class: 'section__description section__description--' + section.descriptionModifier
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(section.title)
        },
        slot: "title"
      }), _vm._v(" "), (section.descriptionModifier !== 'space-around' && section.dataAnchor !== 'ending-page') ? _c('div', {
        domProps: {
          "innerHTML": _vm._s(section.subtitles)
        },
        slot: "subtitle"
      }) : _vm._e(), _vm._v(" "), (section.descriptionModifier === 'space-around') ? _c('div', {
        staticClass: "space-around",
        slot: "issues"
      }, [_vm._l((section.issues), function(issue, i) {
        return [_c('div', {
          staticClass: "space-around__container space-around__container--invisible",
          style: ('position: relative; animation-delay: .7s')
        }, [_c('div', {
          domProps: {
            "innerHTML": _vm._s(issue.title)
          }
        }), _vm._v(" "), _c('div', {
          domProps: {
            "innerHTML": _vm._s(issue.subtitle)
          }
        }), _vm._v(" "), _c('ButtonMore', {
          attrs: {
            "state": 'open-issue-btn',
            "theme": 'hamburger--background-dark'
          },
          on: {
            "readissues": function($event) {
              _vm.readIssues(issue)
            }
          }
        })], 1), _vm._v(" "), (i !== 2) ? _c('div', {
          staticClass: "vertical-line vertical-line--invisible",
          style: ('animation-delay: .7s')
        }) : _vm._e()]
      })], 2) : _vm._e(), _vm._v(" "), (section.dataAnchor === 'ending-page') ? _c('div', {
        staticClass: "credits",
        domProps: {
          "innerHTML": _vm._s(section.subtitles)
        },
        slot: "credits"
      }) : _vm._e(), _vm._v(" "), (section.dataAnchor === 'ending-page') ? _c('RelatedPost', {
        slot: "related-posts"
      }) : _vm._e(), _vm._v(" "), (section.dataAnchor === 'ending-page') ? _c('div', {
        staticClass: "projects__container",
        attrs: {
          "onclick": "ga('send', 'event', 'projects', 'click', 'projects', { nonInteraction: false })"
        },
        slot: "projects"
      }, [_c('p', {
        staticClass: "projects__container-title"
      }, [_vm._v("看更多專題")]), _vm._v(" "), _c('iframe', {
        staticStyle: {
          "width": "1px",
          "min-width": "100%",
          "*width": "100%"
        },
        attrs: {
          "src": "https://mirrormedia.mg/project-list/dark?excluding=20170801aboriginal",
          "width": "100%",
          "height": "100%",
          "frameborder": "0",
          "scrolling": "no"
        }
      })], 1) : _vm._e(), _vm._v(" "), (section.dataAnchor === 'ending-page') ? _c('div', {
        staticClass: "fb-comments__container",
        slot: "fbcomments"
      }, [_c('div', {
        staticClass: "fb-comments",
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "data-href": "https://www.mirrormedia.mg/projects/20170801aboriginal/",
          "data-colorscheme": "dark",
          "data-numposts": "1",
          "data-width": "100%",
          "data-order-by": "reverse_time"
        }
      })]) : _vm._e()], 1)], 1)
    })
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-009598c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 111
// module chunks = 1